// Luxon Configuration
import type { Zone } from "luxon";
import { DateTime, Settings } from "luxon";

Settings.defaultLocale = "en-au";

// documentation has this always being a `Zone` when getting
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const localZone: Zone = Settings.defaultZone as Zone;
export const utcZone: Zone = DateTime.utc().zone;
